import React, { useEffect, useRef, useState } from 'react';
import { MdAttachFile, MdChat, MdClose, MdErrorOutline } from "react-icons/md";
import { useSelector, useDispatch } from 'react-redux';
import { chatSliceAction } from '../../store/chatSlice';
import { sendMessage, sendAttachment } from '../../store/chatSlice';
import styled from "styled-components";
import { getMessagesByAccount } from '../../utils/awsAPI';
import connectLogo from "./../../assets/images/connect-logo.png";
import { Updatelocal } from "../../utils/utils"

//margin-bottom: 13.56px;

const MessageDiv = styled("div") <{ isYours: boolean }>`
    display: flex;
    justify-content: ${(props) => (props.isYours ? "flex-end" : "flex-start")};
    margin-left: ${(props) => (props.isYours ? "0px" : "auto")};
    margin-right: ${(props) => (props.isYours ? "auto" : "0px")};
    margin-bottom: 5px;
    align-items: center;
`;

const Message = styled("div") <{ isYours: boolean, isSystemMessage: boolean, isChatEnded: boolean, success: boolean }>`
    background: ${(props) => (props.isChatEnded ? (props.isYours ? "#3c3c3c" : "#dcdcdc") : (props.isYours ? (props.success ? "#2300B0" : "#3C3C3C") : (props.isSystemMessage ? "#DCDCDC" : "white")))};
    padding: 5px 10px;
    border-radius: ${(props) => (props.isYours ? "6px 0px 6px 6px" : "0px 6px 6px 6px")};
    max-width: 85%;
    color: ${(props) => (props.isYours ? "white" : "#303030")};
    font-size: 16px;
    word-wrap: break-word;
    white-space: pre-wrap;
    word-break: break-word;
    span {
        font-size: 10px;
        color: ${(props) => (props.isYours ? "white" : "#303030")};
    }
`;

const FileContainer = styled.div`
    display: flex;
    flex-direction: row;
    background: #2300B0;
    align-items: center;
    border-radius: 10px;
    min-height: 2.1rem;
    span {
        font-size: 12px;
        color: white;
        font-weight: bold;
        margin-right: 0.3em;
    }
`;

const PresetMessagesContainer = styled.div`
    background: white;
    margin: 0rem 1.25rem 2rem 1.25rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const PresetMessage = styled("div") <{ index: number }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    background: ${(props) => ((props.index % 2 === 0) ? "white" : "#f5f5f5")};
    cursor: pointer;
    span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.8);
        margin: 5px;
    }
    :hover {
        background: #ebebeb;
    }
`;

const ChatContainer = styled("div") <{ hasSelectedChat: boolean }>`
    background-color: ${(props) => ((props.hasSelectedChat) ? "#efefef" : "white")};
    height: 300px; 
    padding: 15px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;


const PlaceholderContainer = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    gap: 10px;
    color: rgba(0, 0, 0, 0.45);
    span {
        font-size: 26px;
        color: #3c3c3c;
    }
    height: 84vh;
`;

const ChatPlaceholder = styled.img`
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: contain;
`;

const Disabler = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background-color: #3c3c3c;
    opacity: 0.5;
`;

const PresetMessagesPopUp: React.FC<{ presetMessages: any, setText: any, text: any, setPresetMessagesVisible: any, focusInput: Function }> = (props) => {
    var index = 0;

    return (
        <div style={{ display: "flex", flexDirection: "column", position: "absolute", height: "12rem", backgroundColor: "white", borderRadius: "5px", margin: "6.5rem 2rem 0rem 0rem", boxShadow: "0 5px 6px rgb(20 27 43 / 10%)", width: "52.5rem", zIndex: "10000" }}>
            <div style={{ width: "100%", justifyContent: "flex-end" }}>
                <MdClose size={24} color={"#3c3c3c"} cursor={"pointer"} onClick={() => { props.setPresetMessagesVisible(false); }} style={{ float: "right", margin: "1rem 1rem 0.5rem 0rem" }} />
            </div>
            <PresetMessagesContainer>
                {props.presetMessages.map((message: string) => {
                    index++;
                    return (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                            <PresetMessage index={index} onClick={() => { props.setText(props.text + message); props.setPresetMessagesVisible(false); props.focusInput() }}>
                                <span>{message}</span>
                            </PresetMessage>
                        </div>
                    )
                })}
            </PresetMessagesContainer>

        </div>
    );
}



const ChatBox = () => {
    const chatSliceData = useSelector((state: any) => { return state.chatSlice });
    let CurrentStorage = JSON.parse(localStorage.getItem("ChatDrafts") || "{}")
    const [text, setText] = useState(CurrentStorage[chatSliceData.selectedChat] || "");
    const [selectedFile, selectFile] = useState<File>();
    const [presetMessagesVisible, setPresetMessagesVisible] = useState(false);
    const [presetMessages, setPresetMessages] = useState([""]);
    const dispatch = useDispatch();
    const messagesEndRef = useRef<null | HTMLDivElement>(null);
    const [draftTexts, setDraftTexts] = useState<{ [key: string]: string }>({});


    useEffect(() => {
        Updatelocal("ChatDrafts", text, chatSliceData.selectedChat)
        let CurrentStorage = JSON.parse(localStorage.getItem("ChatDrafts") || "{}")
        setDraftTexts(CurrentStorage)
    }, [text]);

    useEffect(() => {
        scrollToBottom(); //- Found the evil source
    }, [chatSliceData])


    useEffect(() => {
        //
        let CurrentStorage = JSON.parse(localStorage.getItem("ChatDrafts") || "{}")
        //
        setText(CurrentStorage[chatSliceData.selectedChat] || "");

    }, [chatSliceData.selectedChat]);


    var agentLanguage = "";
    var language = "";
    var account = "";
    var contactId = "";

    for (let i = 0; i < chatSliceData.chats.length; i++) {
        if (chatSliceData.chats[i]["id"] === chatSliceData.selectedChat) {
            agentLanguage = chatSliceData.chats[i]["agentLanguage"];
            language = chatSliceData.chats[i]["customerLanguage"];
            account = chatSliceData.chats[i]["account"];
            contactId = chatSliceData.chats[i]["id"];
        }
    }

    const scrollToBottom = () => {
        const contains = document.getElementById("Chat-Interactions");
        if (contains) {
            contains.scrollTop = contains.scrollHeight;
        }
    }

    const getTranslationEnabled = (contactInfo: any) => {
        let translationEnabled = "False";
        Object.keys(contactInfo).map((key) => {
            if (key === "TranslationEnabled") {
                translationEnabled = contactInfo[key]["value"];
            }
        })
        return translationEnabled;
    }

    const onEnterPress = async (event: any) => {
        if (event.key === "Enter") {
            event.preventDefault();

            if (event.shiftKey) {
                setText(text + "\r\n");
                return;
            }

            var elements = document.getElementsByClassName('text-input-chat');
            for (var i = 0; i < elements.length; i++) {
                var element = elements[i] as HTMLElement;
                element.style.height = '50px';
            }


            var date = new Date().toString();
            if (selectedFile !== undefined) {
                let url = URL.createObjectURL(selectedFile);
                dispatch(chatSliceAction.addNewAttachment({ participantId: chatSliceData.selectedChat, content: selectedFile.name, participantRole: "AGENT", url: url, dateTime: date }));
                let fileToSend = selectedFile;
                selectFile(undefined);
                let success = await sendAttachment(chatSliceData.chats, chatSliceData.selectedChat, fileToSend);
                if (!success) {
                    dispatch(chatSliceAction.changeAttachment({ participantId: chatSliceData.selectedChat, url: url }));
                }
            }
            if (text !== "" && text.replace(/\s/g, '').length) {
                dispatch(chatSliceAction.addNewMessage({ participantId: chatSliceData.selectedChat, content: text, participantRole: "AGENT", dateTime: date }));
                sendMessage(chatSliceData.chats, chatSliceData.selectedChat, text, language, agentLanguage, contactId, account, getTranslationEnabled(chatSliceData.selectedInfo) === "True", chatSliceData.isTranslationDisabledByAgent, "AGENT");
            }
            setText("");
        }
    }

    function focusInput() {
        document.getElementById("text-input")?.focus();
    }

    return (
        <div className="card wrapup-box collapse show mt-3" id="ChatBox">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>{(chatSliceData.selectedChat === "") ? ("Chat box") : (`Chatting with ${chatSliceData.selectedName}`)}</h6>
            </div>
            <div className="card-body">
                <div className='chat-wapper'>
                    <ChatContainer id="Chat-Interactions" hasSelectedChat={chatSliceData.selectedChat !== ""}>
                        {(chatSliceData.selectedChat === "") ? (
                            <PlaceholderContainer>
                                <ChatPlaceholder src={connectLogo} />
                                <span>{chatSliceData.numberOfChats > 0 ? "You have active chats!" : "You have no active chats at the moment"}</span>
                                <p style={{ color: "#3c3c3c" }}>{chatSliceData.numberOfChats > 0 ? "Select one of your active chats to start chatting!" : "When you accept a chat, it will appear in this window"}</p>
                            </PlaceholderContainer>
                        ) : (
                            chatSliceData.selectedConversation.map((messageData: { [key: string]: any }) => (
                                <div className={ messageData["isYours"] ? 'Agent' : "Customer"}>
                                    <MessageDiv isYours={messageData["isYours"]} >
                                        {(messageData.hasOwnProperty("success") ? messageData["success"] : true) ? (
                                            <></>
                                        ) : (
                                            <MdErrorOutline style={{ fill: "#EA0000", height: "3%", width: "3%", marginRight: "0.25rem" }} />
                                        )}
                                    <Message
                                        title={messageData["dateTime"]}
                                        isYours={messageData["isYours"]}
                                        isSystemMessage={messageData["isSystemMessage"]}
                                        isChatEnded={chatSliceData.isSelectedChatEnded}
                                        success={messageData.hasOwnProperty("success") ? messageData["success"] : true}
                                        className='chatbubble'
                                        >
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <span>{messageData["time"]}</span>
                                            {/* change this when we implement rich text */}
                                            <a>
                                            {(messageData["type"] === "text/plain" || messageData["type"] === "text/markdown") ? (
                                                messageData["message"].includes("AWS_SYS_MESSAGE") ? (
                                                <a style={{ color: "#FF0000", fontWeight: "bold" }}>
                                                    {messageData["message"].replace("\#AWS_SYS_MESSAGE \#", "").replace("#AWS_SYS_MESSAGE#", "")}
                                                </a>
                                                ) : messageData["message"].includes("<AlarmUserLeft>") ? (
                                                <a style={{ color: "#FF0004", fontWeight: "bold" }}>
                                                    {messageData["message"].replace("<AlarmUserLeft>", "")}
                                                </a>
                                                ) : messageData["message"].match(/\bhttps?:\/\/(?:.*\.)?service-now\.com\S*/) ? (
                                                <>
                                                    {messageData["message"].split(/\b(https?:\/\/(?:.*\.)?service-now\.com\S*)/).map((part: string, index: number) =>
                                                    part.match(/\bhttps?:\/\/(?:.*\.)?service-now\.com\S*/) ? (
                                                        messageData["isYours"] ? (
                                                        <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>
                                                            {part}
                                                        </a>
                                                        ) : (
                                                        <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: "#303030", textDecoration: "underline" }}>
                                                            {part}
                                                        </a>
                                                        )
                                                    ) : (
                                                        <a key={index}>{part}</a>
                                                    )
                                                    )}
                                                </>
                                                ) : (
                                                messageData["message"].split(/\*{2}(.*?)\*{2}|\*(.*?)\*/).map((part: string, index: number) => (
                                                    index % 3 === 0 ? (
                                                    <a key={index}>{part}</a>
                                                    ) : index % 3 === 1 ? (
                                                    <a key={index} style={{ fontWeight: "bold" }}>{part}</a>
                                                    ) : (
                                                    <a key={index} style={{ fontStyle: "italic" }}>{part}</a>
                                                    )
                                                ))
                                                )
                                            ) : (
                                                messageData["success"] ? (
                                                <a download={messageData["message"]} href={messageData["url"]} style={messageData["isYours"] ? { color: "white", textDecoration: "underline" } : { color: "#303030", textDecoration: "underline" }}>
                                                    {messageData["message"]}
                                                </a>
                                                ) : (
                                                "There was an error with the attachment " + messageData["message"] + " and it couldn't be sent. Download the logs for more information."
                                                )
                                            )}
                                            </a>
                                        </div>
                                        </Message>




                                    </MessageDiv>
                                    {messageData["needTranslation"] ? (
                                        <span style={{ display: "flex", justifyContent: (messageData["isYours"] ? "flex-end" : "flex-start"), margin: "5px 15px", fontSize: "14px" }}>Translating, please wait</span>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            ))
                        )}
                        {(presetMessagesVisible && !chatSliceData.isSelectedChatEnded) ? (
                            <PresetMessagesPopUp
                                presetMessages={presetMessages}
                                setPresetMessagesVisible={setPresetMessagesVisible}
                                setText={setText}
                                text={text}
                                focusInput={focusInput}
                            />
                        ) : (
                            <></>
                        )}
                        <div ref={messagesEndRef} />
                    </ChatContainer>
                    {(chatSliceData.isSelectedChatEnded || chatSliceData.selectedType === "monitoring" || chatSliceData.selectedChat === "") ? (
                        <></>
                    ) : (
                        <div className='chat-box'>
                            <div className="chat-box-input mt-3 dropdown" style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingRight: "5px" }}>
                                    <label htmlFor="file-input" style={{ height: "100%", display: "flex", alignItems: "center" }}>
                                        <MdAttachFile size={24} color={"gray"} cursor={"pointer"} />
                                    </label>
                                    <input id="file-input" type="file" style={{ display: 'none' }} onChange={(e) => { selectFile(e.target.files![0]); }} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", background: "white", borderRadius: "8px", width: "100%", padding: "5px 10px", gap: "10px", borderStyle: "solid", borderWidth: "1px", borderColor: "gray" }}>
                                    {(selectedFile === undefined) ? (
                                        <></>
                                    ) : (
                                        <FileContainer>
                                            <MdClose size={24} color={"white"} cursor={"pointer"} onClick={() => { selectFile(undefined); }} style={{ marginLeft: "0.3em", marginRight: "0.3em", cursor: "pointer" }} />
                                            {selectedFile.name.length > 55 ? (
                                                <span>{selectedFile.name.slice(0, 52) + "..."}</span>
                                            ) : (
                                                <span>{selectedFile.name}</span>
                                            )}
                                        </FileContainer>
                                    )}
                                    <textarea className="text-input-chat" id="text-input" autoFocus rows={2} placeholder="Type a message and press Enter to send" value={text} onKeyDown={onEnterPress} onChange={(event) => {
                                        setText(event.target.value)
                                        event.target.style.height = event.target.scrollHeight + 'px';
                                    }
                                    } style={{ width: "100%", fontSize: "15px", outline: "none", border: "none" }} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingLeft: "5px" }} onClick={async () => {
                                    if (!presetMessagesVisible) {
                                        setPresetMessages((await getMessagesByAccount(account)).messages);
                                        setPresetMessagesVisible(!presetMessagesVisible);
                                    }
                                }}>
                                    <MdChat size={24} cursor={"pointer"} color={"gray"} />
                                </div>
                                {presetMessagesVisible ? (<Disabler />) : (<></>)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    )
}
export default ChatBox;